// extracted by mini-css-extract-plugin
module.exports = {"editorHeader":"EditorHeader_editorHeader__2Z8fG","inputClass":"EditorHeader_inputClass__3ZJrC"};